import type { CollectionExport } from '@/types/global';

type PrintLog = {
	collectionId: string;
	collectionObject: string;
	collectionSiteId: string;
	createdAt: number;
	createdBy: string;
	updatedAt: number;
	isError: boolean;
	lastSyncAttempt: number;
	syncAttempts: number;
	inProgress: boolean;
};

export const printlogs: CollectionExport<PrintLog> = {
	schema: {
		title: 'printlogs',
		version: 1,
		primaryKey: 'collectionId',
		type: 'object',
		properties: {
			collectionId: {
				type: 'string',
				maxLength: 30
			},
			collectionObject: {
				type: 'string'
			},
			collectionSiteId: {
				type: 'string'
			},
			createdAt: {
				type: 'datetime'
			},
			createdBy: {
				type: 'string'
			},
			updatedAt: {
				type: 'datetime'
			},
			isError: {
				type: 'boolean'
			},
			lastSyncAttempt: {
				type: 'datetime'
			},
			syncAttempts: {
				type: 'number'
			},
			inProgress: {
				type: 'boolean'
			}
		},
		encrypted: [ 'collectionObject' ]
	}
};
